import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  hrinfo: '',
  newname: '',
  targetShow: true,
  searchcons: '',
  fontSize: 10,
  aiBatchData: ''
};
const getters = {
  hrname(state) {
    let hrname = '';
    if (state.hrinfo) {
      hrname = state.hrinfo.name;
    }
    return hrname;
  },
  hrimg(state) {
    let hrimg = '';
    if (state.hrinfo) {
      hrimg = state.hrinfo.headImage;
    }
    return hrimg;
  },
  fontSize(state) {
    return state.fontSize;
  },
  getAiBatchData(state) {
    return state.aiBatchData;
  }
};
const mutations = {
  setAiBatchData(state, data) {
    state.aiBatchData = data;
  },
  searchChange(state, name) {
    state.searchcons = name;
  },
  hrinfoMo(state, obj) {
    state.hrinfo = obj;
    if (obj.name) {
      state.newname = obj.name;
    }
  },
  hrChnageImg(state, name) {
    state.hrinfo.headImage = name;
  },
  hrChnageName(state, name) {
    state.hrinfo.name = name;
  },
  getnewName(state, name) {
    state.newname = name;
  },
  targetShow(state, val) {
    state.targetShow = val !== 'isresumeInfo';
  },
  setFontSize(state) {
    let fontSize = window.innerWidth / 1440 * 10;
    fontSize = fontSize > 14 ? 14 : fontSize;
    document.getElementsByTagName('html')[0].style = `font-size: ${fontSize}px`;
    state.fontSize = fontSize
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js